import {Component} from 'panel';

import {defineAndMakeJsxFactory} from 'common/util/jsx';
import {panel2react} from 'common/util/react';

import {template} from './template';
import css from './index.inline.styl';

export class Mp404Screen extends Component<EmptyObj> {
  get config() {
    return {
      css,
      useShadowDom: true,
      template,
      helpers: {
        shouldShowDashboardLink: () => /mixpanel\.(com|org)/.exec(window.origin),
      },
    };
  }
}

export const Mp404ScreenEl = defineAndMakeJsxFactory(`mp-404-screen`, Mp404Screen);
export const Mp404ScreenReact = panel2react(`mp-404-screen`, Mp404Screen);
